import moment from 'moment';
import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Button, Row, Col, Modal, Card, CardBody, Form, Label, Input, FormGroup, FormFeedback } from "reactstrap";
import delivery from './../../../assets/images/svg/deliver-icon.svg';
import ship from '../../../assets/images/cargo-ship.png';
import air from '../../../assets/images/airplane.png';
import deliverysucess from "../../../assets/images/svg/deliver-icon-sucess.svg"
import NoDataFound from 'components/Common/NoDataFound';
import discharge_from_barge from '../../../assets/images/svg/booking-track/disshage-from-barge.svg'
import empty_container_gate_in from '../../../assets/images/svg/booking-track/empty-container-gate-in.svg'
import empty_container_gate_out from '../../../assets/images/svg/booking-track/empty-container-gate-out.svg'
import full_container_gate_in from '../../../assets/images/svg/booking-track/full-container-gate-in.svg'
import full_container_gate_out from '../../../assets/images/svg/booking-track/full-container-gate-out.svg'
import load_on_vessel from '../../../assets/images/svg/booking-track/load-on-vessel.svg'
import { useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import { trackBooking } from 'store/actions';

const TrackDetails = ({ data, bookinginfo }) => {
    const history = useHistory()
    const DateFormat = (value, format) => {
        let result;
        if (format === 'day') {
            result = moment(value).format('dddd')
            return result
        } else if (format === 'time') {
            result = moment(value).format('LT')
            return result
        } else if (format === 'date') {
            result = moment(value).format('MMM Do yyyy')
            return result
        }
    }

    const iconPath = (value) => {
        if (value.code === 'gateOutWithContainerEmpty') return empty_container_gate_out
        if (value.code === "gateOutWithContainerFull") return full_container_gate_out
        if (value.code === "gateInWithContainerEmpty") return empty_container_gate_in
        if (value.code === "gateInWithContainerFull") return full_container_gate_in
        if (value.code === "loadOnVessel") return load_on_vessel
        if (value.code === "dischargeFromBarge") return discharge_from_barge
        if (value.code === "loadOnBarge") return load_on_vessel
        // if (value.code === "birthing") return birthing         // we need icon
    }

    const { loading } = useSelector(state => ({
        loading: state.TrackBookings?.loading
    }))

    return (
        <>
            <Col>
                <h2 className='mt-4'>Tracking History</h2>
                {loading === true ? <>
                    {[...Array(3)].map((item, index) => {
                        return <React.Fragment key={index}>
                            <div className={`status-list ${data?.track && data?.track[0]?.status === "COMPLETED" ? "completed" : ""}`}>
                                <div className='d-flex'>
                                    <div className='day-date'>
                                        <Skeleton height={"20px"} width={'120px'} />
                                    </div>
                                    <div className='day-date-mobile'>
                                        <Skeleton height={"20px"} width={'120px'} />
                                        <Skeleton height={"20px"} width={'120px'} />
                                    </div>
                                </div>
                                <div className='status'>
                                    <div className='time'>
                                        <Skeleton height={"20px"} width={'120px'} />
                                    </div>
                                    <div className='status-details'>
                                        <div className='icon'>
                                            <Skeleton height={"45px"} width={'45px'} />
                                        </div>
                                        <div>
                                            <Skeleton height={"20px"} width={'120px'} />
                                            <Skeleton height={"20px"} width={'120px'} />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </React.Fragment>
                    })}
                </> : <>
                    {data?.track && data?.track && data?.track[0]?.shipmentEvents.length > 0 ?
                        <Card>
                            <CardBody>
                                {data?.track && data?.track[0]?.shipmentEvents?.map((item, index) => {
                                    return <React.Fragment key={index}>
                                        <div className='status-list'>
                                            <div className='d-flex'>
                                                <div className='day-date'>
                                                    <p className='m-0 day'>{DateFormat(item?.date, "day")},</p>
                                                    <p className='date'>{DateFormat(item?.date, "date")}</p>
                                                </div>
                                                <div className='day-date-mobile'>
                                                    <p className='m-0 day'>{DateFormat(item?.date, "day")},</p>
                                                    <p className='date'>{DateFormat(item?.date, "date")}</p>
                                                </div>
                                            </div>
                                            {item.events.map((value, idx) => {
                                                return <React.Fragment key={idx}>
                                                    <div className='status'>
                                                        <div className='time'>
                                                            <p>{DateFormat(value.actualTime, "time")}</p>
                                                        </div>
                                                        <div className='status-details'>
                                                            <div className='icon'>
                                                                <img src={iconPath(value)} alt="delivery" />
                                                            </div>
                                                            <div>
                                                                <p className='m-0 title'>{value.name} <span>-({DateFormat(value.actualTime, "time")})</span></p>
                                                                <p>{value.location}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            })}
                                        </div>
                                    </React.Fragment>
                                })}
                                {data?.track && data?.track[0]?.status === "COMPLETED" ?
                                    <div className='status-list'>
                                        <div className='status'>
                                            <div className='time'>

                                            </div>
                                            <div className='status-details'>
                                                <div className='icon'>
                                                    <img src={deliverysucess} alt="delivery" />
                                                </div>
                                                <div>
                                                    <p className='title'>Shipping</p>
                                                    <p>completed</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div> : null
                                }

                            </CardBody>
                        </Card> :
                        <Card className='not-fount'>
                            <CardBody className='text-center py-5' >
                                {bookinginfo && bookinginfo[0].type == "BY SHIP" ?
                                    <img src={ship} className={'mb-0'} alt={"ship"} width={"50px"} />
                                    : ""}
                                {bookinginfo && bookinginfo[0].type == "BY AIR" ?
                                    <img src={air} className={'mb-0'} alt={"ship"} width={"50px"} />
                                    : ""}
                                <p className='m-0 mt-2'>No tracking record available</p>
                            </CardBody>
                        </Card>
                    }</>}
                <div className='text-center'>
                    <button className="mb-4 secountry-btn" onClick={() => history.push("/bookings")}>Back</button>
                </div>
            </Col>
        </>
    )
}

export default TrackDetails;